import React from 'react';
import { IconProps } from './types';

export const SearchIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      id="Laag_2"
      data-name="Laag 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      className={className}
    >
      <title>{title}</title>
      <path d="M28.61,27.24,21.4,20A11,11,0,1,0,20,21.45l7.2,7.21a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29A1,1,0,0,0,28.61,27.24ZM4,13a9,9,0,1,1,9,9A9,9,0,0,1,4,13Z" />
    </svg>
  );
};
